declare global {
    interface Window {
        baseUrl: any;
    }
}

export const BASE_URL =
    process.env.REACT_APP_API_BASE_URL || `${window.baseUrl}`;
